import { SiteLink } from "shared/components/SiteLink";
import { PERSON_TYPE } from "clariah/utils/constants";
import { SrcSet } from "shared/components/SrcSet";
import styles from "./PersonCard.module.css";

export const PersonCard = ({ name, slug, image, titles }) => (
  <div className={styles.container}>
    <SiteLink href={slug.current} type={PERSON_TYPE}>
      <div className={styles.content}>
        {image && (
          <SrcSet
            alt={name}
            sizes={[{ minWidth: 768, width: 120, ratio: 1 }]}
            sizes={[{ minWidth: 1, width: 100, ratio: 1 }]}
            src={image.url}
          />
        )}
        <h2 className={styles.name}>{name}</h2>
        {titles && (
          <p className={styles.titles}>
            {titles
              .filter(Boolean)
              .map(({ title, organization }) =>
                [title, organization].filter(Boolean).join(", ")
              )
              .join("  •  ")}
          </p>
        )}
      </div>
    </SiteLink>
  </div>
);
